import { render, staticRenderFns } from "./clientView.vue?vue&type=template&id=3374579e&scoped=true"
import script from "./clientView.vue?vue&type=script&lang=js"
export * from "./clientView.vue?vue&type=script&lang=js"
import style0 from "./clientView.vue?vue&type=style&index=0&id=3374579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374579e",
  null
  
)

export default component.exports